// ======================================================================
// File: src/modules/ppe/components/common/SearchableDropdown.jsx
// Purpose:
// - Generic reusable searchable dropdown component
// - Async search with API
// - Supports multiple API response formats
// ======================================================================

import React, { useEffect, useState } from "react";

export default function SearchableDropdown({
  label,
  value,
  onChange,
  fetchOptions,
  placeholder = "Search...",
  getOptionLabel = (o) => o.label,
  getOptionValue = (o) => o.id,
  disabled = false,
}) {
  const [search, setSearch] = useState(value || "");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  // Sync external value
  useEffect(() => {
    setSearch(value || "");
  }, [value]);

  useEffect(() => {
  // Immediately clear old options on new search
  setOptions([]);

  if (!search || search.length < 2) {
    return;
  }


    const load = async () => {
      setLoading(true);

      try {
        let result = await fetchOptions(search);

        // ---- NORMALIZE RESPONSE FORMAT ----

        let data = [];

        if (!result) {
          data = [];
        }
        // Direct array
        else if (Array.isArray(result)) {
          data = result;
        }
        // { data: [...] }
        else if (Array.isArray(result.data)) {
          data = result.data;
        }
        // { items: [...] }
        else if (Array.isArray(result.items)) {
          data = result.items;
        }
        // { data: { items: [...] } }
        else if (
          result.data &&
          Array.isArray(result.data.items)
        ) {
          data = result.data.items;
        }
        // Unknown format
        else {
          data = [];
        }

        setOptions(data);

      } catch (error) {
        console.error("Dropdown fetch error:", error);
        setOptions([]);
      }

      setLoading(false);
    };

    const timer = setTimeout(load, 400);
    return () => clearTimeout(timer);

  }, [search, fetchOptions]);

  const handleSelect = (opt) => {
    onChange(opt);
    setSearch(getOptionLabel(opt));
    setShow(false);
  };

  return (
    <div style={{ position: "relative" }}>
      {label && <label className="form-label">{label}</label>}

      <input
        className="form-control"
        value={search}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => {
          setSearch(e.target.value);
          setShow(true);
        }}
        onFocus={() => {
          if (search) setShow(true);
        }}
      />

      {show && search && (
        <div
          style={{
            position: "absolute",
            background: "#fff",
            border: "1px solid #ddd",
            width: "100%",
            maxHeight: 200,
            overflowY: "auto",
            zIndex: 9999,
          }}
        >
          {loading && (
            <div className="p-2 text-muted">
              Searching...
            </div>
          )}

          {!loading &&
            (!Array.isArray(options) ||
              options.length === 0) && (
              <div className="p-2 text-muted">
                No results
              </div>
            )}

          {Array.isArray(options) &&
            options.map((opt) => (
              <div
                key={getOptionValue(opt)}
                onClick={() => handleSelect(opt)}
                style={{
                  padding: 8,
                  cursor: "pointer",
                  borderBottom: "1px solid #f1f1f1",
                }}
              >
                {getOptionLabel(opt)}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
